import { getCourseDetails  } from '../services/vu'
import { getPreferredCourse, updatePreferredCourse } from '../services/vu'

export const fetchRequiredCourse = (selectCourse) => {
  return (dispatch, getState) => {
    return dispatch(fetchCourseIfNeeded(selectCourse))
  }
}

export const fetchCourseIfNeeded = (selectCourse) => {
  return (dispatch, getState) => {
    if (shouldFetchCourse(getState(), selectCourse)) {
      return dispatch(fetchCourse(selectCourse))
    }
    return Promise.resolve()
  }
}

export const fetchAndUpdatePreferredCourse = (course, isfetchCourse = true) => {
  return dispatch => {
    return updatePreferredCourse(course.courseCode).then(() => {
      if (isfetchCourse) {
        dispatch(selectCourse(course.courseCode))
        return dispatch(setCourse(course))
      } else {
        return dispatch(selectCourse(course.courseCode));
      }
    })
  }
}

const shouldFetchCourse = (state, selectCourse) => {
  return !state.course.selectedCourse || (selectCourse && state.course.selectedCourse.courseCode !== selectCourse.courseCode)
}


export const fetchCourse = (course) => {
  return dispatch => {
    dispatch(requestCourse())

    let queryParams = {}

    queryParams["attemptNumber"] = course.attemptNumber
    queryParams["versionNumber"] = course.versionNumber
    queryParams["courseSSPNo"] = course.parentSSPNo
    queryParams["parentSSPNo"] = course.parentSSPNo

    return getCourseDetails(course.courseCode, queryParams).then((course = {}) => {
      return dispatch(receiveCourse(course))
    })
  }
}

export const setCourse = (course) => {
  return dispatch => {
    return dispatch(receiveCourse(course))
  }
}

const selectCourse = courseCode => {
  return {
    type: 'SELECT_COURSE',
    courseCode
  }
}

const requestCourse = () => {
  return {
    type: 'REQUEST_COURSE'
  }
}
const receiveCourse = (course) => {
  return {
    type: 'RECEIVE_COURSE',
    course
  }
}